import { WebApiActionGet, WebApiActionPost, WebApiItems } from "components/ajax/WebApi";
import baseUrl from "./url";

const bodyZahrSoutUrl = baseUrl + 'pripsani-bodu-zahranicni-souteze/'

export interface ZadostForm {
    SoutDatum: string;
    SoutNazev: string;
    SoutMisto: string;
    SoutStat: string;
    SoutVekKtg: string;
    SoutVykTrida: string;
    SoutDisciplina: string;
    SoutPocetParu: string;
    SoutPocKolektivnichClenu: string;
    ParPartnerIdt: number;
    ParPartnerkaIdt: number;
    ParPocetKol: string;
    ParUmisteni: string;
    ParVeFinale: string;
    DolozeniUrlAdresa?: string;
    DolozeniSoubor?: ZadostFormSoubor;
    CheckValidity: boolean;
}

export interface ZadostFormSoubor {
    Field: string;
    Nazev: string;
    Ulozeni: string;
}

export interface ZadostSz {

}

export interface ZadostDetail {

}


export const apiSeznamZadosti = function (): WebApiActionGet<WebApiItems<ZadostSz>> {
    return new WebApiActionGet<WebApiItems<ZadostSz>>(bodyZahrSoutUrl + 'seznam-zadosti');
}

export const apiDetailZadosti = function (zadostId: number): WebApiActionGet<ZadostSz> {
    return new WebApiActionGet<ZadostSz>(bodyZahrSoutUrl + `detail-zadosti/${zadostId}`);
}

export const apiZadostPost = function (): WebApiActionPost<ZadostForm, ZadostDetail> {
    return new WebApiActionPost<ZadostForm, ZadostDetail>(bodyZahrSoutUrl + 'zadost');
}

export const apiZadostUploadFiles = function (): WebApiActionPost<FormData, ZadostFormSoubor> {
    return new WebApiActionPost<FormData, ZadostFormSoubor>(bodyZahrSoutUrl + 'zadost/upload-files', 'formData');
}